(() => {
  const story = document.getElementById('epilogueStory');
  const sticky = document.getElementById('epilogueSticky');
  const sliceGate = document.getElementById('sliceGate');
  const finaleSplitGate = document.getElementById('finaleSplitGate');
  const sourcePanel = document.querySelector('.heritage-panel:last-child');
  const rhythmPanel = document.querySelector('.rhythm-panel');
  const rhythmMedia = rhythmPanel?.querySelector('.rhythm-media');
  const rhythmBaseImage = rhythmMedia?.querySelector('img');
  const finalePanel = document.querySelector('.finale-panel');
  const seamLine = document.getElementById('seamLine');
  const dayReadout = document.getElementById('ritualDay');
  const dayTicks = [...document.querySelectorAll('.day-scale i')];
  const finaleLines = [...document.querySelectorAll('.finale-title i')];
  const comparisonPortraits = [...document.querySelectorAll('.comparison-portrait')];
  const comparisonImages = [...document.querySelectorAll('.comparison-portrait img')];
  const comparisonSides = [...document.querySelectorAll('.comparison-side')];
  const comparisonLines = [...document.querySelectorAll('.compare-line > i')];
  const comparisonDescriptions = [...document.querySelectorAll('.comparison-description')];
  const comparisonBridge = document.querySelector('.comparison-bridge');
  const precisionCanvas = null;
  const precisionImage = null;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!story || !sticky || !rhythmPanel || !finalePanel) return;
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const smooth = value => { const n = clamp(value); return n * n * (3 - 2 * n); };
  const state = { pointerY: .5, targetY: .5, pointerX: .5, targetX: .5 };
  const slices = [];
  const finaleSplitPieces = [];
  const finaleSplitReadouts = [];
  const finaleSplitTickSets = [];

  if (rhythmMedia && rhythmBaseImage && !rhythmMedia.querySelector('.rhythm-skin-tone')) {
    const skinToneLayer = rhythmBaseImage.cloneNode(false);
    skinToneLayer.className = 'rhythm-skin-tone';
    skinToneLayer.alt = '';
    skinToneLayer.setAttribute('aria-hidden', 'true');
    rhythmBaseImage.insertAdjacentElement('afterend', skinToneLayer);
  }

  if (!reduceMotion && sourcePanel && sliceGate) {
    const count = 2;
    for (let index = 0; index < count; index += 1) {
      const piece = document.createElement('div');
      piece.className = `slice-piece slice-piece-${index === 0 ? 'top' : 'bottom'}`;
      piece.style.clipPath = index === 0 ? 'inset(0 0 50% 0)' : 'inset(50% 0 0 0)';
      piece.dataset.direction = index % 2 === 0 ? '-1' : '1';
      const clone = sourcePanel.cloneNode(true);
      clone.removeAttribute('data-depth-step');
      clone.setAttribute('aria-hidden', 'true');
      clone.style.setProperty('--heritage-image-y', '0px');
      clone.style.setProperty('--heritage-image-scale', '1.055');
      clone.style.opacity = '1';
      clone.style.visibility = 'visible';
      clone.style.transform = 'none';
      clone.style.filter = 'none';
      piece.appendChild(clone);
      sliceGate.appendChild(piece);
      slices.push(piece);
    }
  }

  if (!reduceMotion && rhythmPanel && finaleSplitGate) {
    for (let index = 0; index < 2; index += 1) {
      const piece = document.createElement('div');
      piece.className = `finale-split-piece finale-split-piece-${index === 0 ? 'top' : 'bottom'}`;
      piece.style.clipPath = index === 0 ? 'inset(0 0 50% 0)' : 'inset(50% 0 0 0)';
      piece.dataset.direction = index === 0 ? '-1' : '1';
      const clone = rhythmPanel.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      clone.querySelectorAll('[aria-live]').forEach(node => node.removeAttribute('aria-live'));
      piece.appendChild(clone);
      finaleSplitGate.appendChild(piece);
      finaleSplitPieces.push(piece);
      finaleSplitReadouts.push(clone.querySelector('.day-readout b'));
      finaleSplitTickSets.push([...clone.querySelectorAll('.day-scale i')]);
    }
  }

  function updatePointer(clientX, clientY) {
    const rect = sticky.getBoundingClientRect();
    state.targetX = clamp((clientX - rect.left) / Math.max(1, rect.width));
    state.targetY = clamp((clientY - rect.top) / Math.max(1, rect.height));
  }
  sticky.addEventListener('pointermove', event => updatePointer(event.clientX, event.clientY), { passive: true });
  sticky.addEventListener('pointerdown', event => updatePointer(event.clientX, event.clientY), { passive: true });
  sticky.addEventListener('touchmove', event => { const touch = event.touches[0]; if (touch) updatePointer(touch.clientX, touch.clientY); }, { passive: true });

  if (reduceMotion) {
    dayReadout.textContent = '14';
    sticky.style.setProperty('--rhythm-skin-brightness', '.93');
    sticky.style.setProperty('--rhythm-skin-saturation', '1.32');
    sticky.style.setProperty('--rhythm-skin-sepia', '.23');
    sticky.style.setProperty('--rhythm-skin-contrast', '1.05');
    dayTicks.forEach(tick => { tick.style.setProperty('--day-height', '22px'); tick.style.setProperty('--day-color', '#e4b574'); });
    return;
  }

  sticky.style.visibility = 'hidden';
  sticky.style.opacity = '0';

  function createRefraction() {
    if (!precisionCanvas || !precisionImage) return null;
    const gl = precisionCanvas.getContext('webgl2', { alpha: true, antialias: false, depth: false, premultipliedAlpha: false, powerPreference: 'high-performance' });
    if (!gl) {
      precisionCanvas.style.display = 'none';
      return null;
    }
    const vertexSource = `#version 300 es
      precision highp float;
      out vec2 vUv;
      void main() {
        vec2 position = vec2(float((gl_VertexID << 1) & 2), float(gl_VertexID & 2));
        vUv = position;
        gl_Position = vec4(position * 2.0 - 1.0, 0.0, 1.0);
      }`;
    const fragmentSource = `#version 300 es
      precision highp float;
      in vec2 vUv;
      out vec4 outColor;
      uniform sampler2D uTexture;
      uniform vec2 uResolution;
      uniform vec2 uImageSize;
      uniform vec2 uPointer;
      uniform vec2 uFocus;
      uniform float uTime;
      uniform float uEnergy;

      vec2 coverUv(vec2 uv) {
        float screenAspect = uResolution.x / max(1.0, uResolution.y);
        float imageAspect = uImageSize.x / max(1.0, uImageSize.y);
        vec2 scale = vec2(1.0);
        if (screenAspect > imageAspect) scale.y = imageAspect / screenAspect;
        else scale.x = screenAspect / imageAspect;
        return (uv - 0.5) * scale + uFocus;
      }

      float grain(vec2 p) {
        return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453123);
      }

      void main() {
        float aspect = uResolution.x / max(1.0, uResolution.y);
        vec2 plane = (vUv - 0.5) * vec2(aspect, 1.0);
        float t = uTime * 0.42;
        vec2 flow = vec2(
          sin(plane.y * 10.0 - t * 1.15) + sin((plane.x + plane.y) * 6.0 + t * 0.72),
          cos(plane.x * 8.5 + t) + cos((plane.x - plane.y) * 7.0 - t * 0.58)
        ) * (0.00145 * uEnergy);
        vec2 pointerDelta = (vUv - uPointer) * vec2(aspect, 1.0);
        float pointerInfluence = exp(-dot(pointerDelta, pointerDelta) * 3.4);
        flow += vec2(-pointerDelta.y, pointerDelta.x) * pointerInfluence * (0.0038 * uEnergy);

        vec2 uv = clamp(coverUv(vUv + flow), vec2(0.001), vec2(0.999));
        vec2 prism = flow * 0.72 + vec2(0.00055, -0.00032) * uEnergy;
        float red = texture(uTexture, clamp(uv + prism, vec2(0.001), vec2(0.999))).r;
        float green = texture(uTexture, uv).g;
        float blue = texture(uTexture, clamp(uv - prism, vec2(0.001), vec2(0.999))).b;
        vec3 color = vec3(red, green, blue);
        color = pow(max(color, 0.0), vec3(0.965));
        color *= vec3(1.015, 0.985, 0.94);
        float materialLight = (sin(plane.x * 4.2 + plane.y * 3.1 + t * 0.6) * 0.5 + 0.5) * 0.018 * uEnergy;
        color += materialLight * vec3(1.0, 0.78, 0.51);
        color += (grain(gl_FragCoord.xy + uTime) - 0.5) * 0.009;
        outColor = vec4(color, 1.0);
      }`;

    function compile(type, source) {
      const shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        gl.deleteShader(shader);
        return null;
      }
      return shader;
    }
    const vertex = compile(gl.VERTEX_SHADER, vertexSource);
    const fragment = compile(gl.FRAGMENT_SHADER, fragmentSource);
    if (!vertex || !fragment) {
      precisionCanvas.style.display = 'none';
      return null;
    }
    const program = gl.createProgram();
    gl.attachShader(program, vertex);
    gl.attachShader(program, fragment);
    gl.linkProgram(program);
    gl.deleteShader(vertex);
    gl.deleteShader(fragment);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      precisionCanvas.style.display = 'none';
      return null;
    }
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    const uniforms = {
      resolution: gl.getUniformLocation(program, 'uResolution'),
      imageSize: gl.getUniformLocation(program, 'uImageSize'),
      pointer: gl.getUniformLocation(program, 'uPointer'),
      focus: gl.getUniformLocation(program, 'uFocus'),
      time: gl.getUniformLocation(program, 'uTime'),
      energy: gl.getUniformLocation(program, 'uEnergy')
    };
    const refraction = { gl, program, texture, uniforms, ready: false, imageWidth: 1, imageHeight: 1 };
    const upload = () => {
      if (!precisionImage.naturalWidth) return;
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, precisionImage);
      refraction.imageWidth = precisionImage.naturalWidth;
      refraction.imageHeight = precisionImage.naturalHeight;
      refraction.ready = true;
    };
    if (precisionImage.complete) upload();
    else precisionImage.addEventListener('load', upload, { once: true });
    return refraction;
  }

  const refraction = createRefraction();

  function drawRefraction(now, progress) {
    if (!refraction || !refraction.ready || progress > .42) return;
    const { gl, program, texture, uniforms } = refraction;
    const rect = precisionCanvas.getBoundingClientRect();
    const pixelRatio = Math.min(window.devicePixelRatio || 1, window.innerWidth < 681 ? 1.15 : 1.35);
    const width = Math.max(1, Math.round(rect.width * pixelRatio));
    const height = Math.max(1, Math.round(rect.height * pixelRatio));
    if (precisionCanvas.width !== width || precisionCanvas.height !== height) {
      precisionCanvas.width = width;
      precisionCanvas.height = height;
    }
    gl.viewport(0, 0, width, height);
    gl.useProgram(program);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.uniform2f(uniforms.resolution, width, height);
    gl.uniform2f(uniforms.imageSize, refraction.imageWidth, refraction.imageHeight);
    gl.uniform2f(uniforms.pointer, state.pointerX, 1 - state.pointerY);
    gl.uniform2f(uniforms.focus, window.innerWidth < 681 ? .64 : .5, .5);
    gl.uniform1f(uniforms.time, now * .001);
    const pageEnergy = .66 + smooth(clamp((progress - .025) / .19)) * .3;
    gl.uniform1f(uniforms.energy, pageEnergy);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
  }

  function render(now = 0) {
    state.pointerX += (state.targetX - state.pointerX) * .075;
    state.pointerY += (state.targetY - state.pointerY) * .075;
    const rect = story.getBoundingClientRect();
    const range = Math.max(1, story.offsetHeight - window.innerHeight);
    const progress = clamp(-rect.top / range);
    const epilogueLatched = rect.top <= .5;
    sticky.style.visibility = epilogueLatched ? 'visible' : 'hidden';
    sticky.style.opacity = epilogueLatched ? '1' : '0';

    const slicePhase = smooth(clamp(progress / .072));
    const sealProgress = clamp(progress / .052);
    const sealPulse = Math.sin(sealProgress * Math.PI) * (1 - slicePhase * .55);
    sticky.style.setProperty('--seal-alpha', `${(sealPulse * .72).toFixed(3)}`);
    sticky.style.setProperty('--seal-scale', `${(.72 + sealProgress * .52).toFixed(3)}`);
    slices.forEach((piece, index) => {
      const direction = Number(piece.dataset.direction);
      const hinge = direction * slicePhase * 1.2;
      piece.style.transform = `translate3d(0, ${(direction * slicePhase * 104).toFixed(3)}%, 0) rotateX(${hinge.toFixed(3)}deg) scale(${(1 - slicePhase * .012).toFixed(4)})`;
    });
    if (sliceGate) sliceGate.style.visibility = progress > .082 ? 'hidden' : 'visible';

    const portraitStarts = [.006, .016];
    comparisonPortraits.forEach((portrait, index) => {
      const reveal = smooth(clamp((progress - portraitStarts[index]) / .108));
      const direction = index === 0 ? -1 : 1;
      portrait.style.setProperty('--portrait-x', `${(direction * (1 - reveal) * 103).toFixed(3)}%`);
      portrait.style.setProperty('--portrait-alpha', `${clamp(reveal * 1.55).toFixed(3)}`);
    });
    comparisonImages.forEach((image, index) => {
      const direction = index === 0 ? -1 : 1;
      const scrollSettle = (1 - smooth(clamp((progress - .04) / .13))) * direction * 17;
      const pointerDrift = (state.pointerX - .5) * direction * 7;
      const idleDrift = Math.sin(now * .00042 + index * 1.7) * 1.8;
      image.style.setProperty('--portrait-drift-x', `${(scrollSettle + pointerDrift + idleDrift).toFixed(2)}px`);
      image.style.setProperty('--portrait-drift-y', `${((state.pointerY - .5) * -4 + Math.cos(now * .00037 + index) * 1.3).toFixed(2)}px`);
    });
    const contourIdleX = Math.sin(now * .00017) * 4.6;
    const contourIdleY = Math.cos(now * .00013) * 3.4;
    sticky.style.setProperty('--compare-contour-x', `${((state.pointerX - .5) * -10 + contourIdleX).toFixed(2)}px`);
    sticky.style.setProperty('--compare-contour-y', `${((state.pointerY - .5) * -8 + contourIdleY).toFixed(2)}px`);
    sticky.style.setProperty('--compare-ambient-r', `${(Math.sin(now * .00011) * 1.1).toFixed(3)}deg`);

    comparisonSides.forEach((side, index) => {
      const reveal = smooth(clamp((progress - (.148 + index * .018)) / .077));
      side.style.setProperty('--compare-copy-alpha', `${reveal.toFixed(3)}`);
      side.style.setProperty('--compare-copy-y', `${((1 - reveal) * 34).toFixed(2)}px`);
      side.style.transform = `translate3d(0, ${((1 - reveal) * 34).toFixed(2)}px, 0) rotateX(${((1 - reveal) * -7).toFixed(2)}deg)`;
    });
    comparisonLines.forEach((line, index) => {
      const reveal = smooth(clamp((progress - (.15 + index * .014)) / .072));
      line.style.setProperty('--compare-line-y', `${((1 - reveal) * 118).toFixed(2)}%`);
      line.style.setProperty('--compare-line-rx', `${((1 - reveal) * -22).toFixed(2)}deg`);
    });
    comparisonDescriptions.forEach((description, index) => {
      const reveal = smooth(clamp((progress - (.205 + index * .016)) / .066));
      description.style.setProperty('--compare-detail-alpha', `${reveal.toFixed(3)}`);
      description.style.setProperty('--compare-detail-y', `${((1 - reveal) * 22).toFixed(2)}px`);
    });
    if (comparisonBridge) {
      const bridgeReveal = smooth(clamp((progress - .118) / .085));
      comparisonBridge.style.setProperty('--compare-bridge-alpha', `${(bridgeReveal * .92).toFixed(3)}`);
      comparisonBridge.style.setProperty('--compare-bridge-scale', `${(.72 + bridgeReveal * .28).toFixed(3)}`);
    }

    drawRefraction(now, progress);

    const precisionPresence = 1 - smooth(clamp((progress - .31) / .08));
    const materialDriftX = (state.pointerX - .5) * 13 + Math.sin(now * .00055) * 3.2;
    const materialDriftY = (state.pointerY - .5) * 9 + Math.cos(now * .00043) * 2.4;
    sticky.style.setProperty('--material-dx', `${materialDriftX.toFixed(2)}px`);
    sticky.style.setProperty('--material-dy', `${materialDriftY.toFixed(2)}px`);
    sticky.style.setProperty('--material-rotate', `${((state.pointerX - .5) * 18 + now * .0038).toFixed(2)}deg`);
    sticky.style.setProperty('--material-scale', `${(.96 + Math.sin(now * .0011) * .025 + (state.pointerY - .5) * .035).toFixed(3)}`);
    sticky.style.setProperty('--material-alpha', `${(.22 + precisionPresence * .25).toFixed(3)}`);
    sticky.style.setProperty('--material-light-x', `${(61 + state.pointerX * 18).toFixed(2)}%`);
    sticky.style.setProperty('--material-light-y', `${(20 + state.pointerY * 24).toFixed(2)}%`);
    sticky.style.setProperty('--precision-shift-x', `${((state.pointerX - .5) * -8).toFixed(2)}px`);
    sticky.style.setProperty('--precision-shift-y', `${((state.pointerY - .5) * -6 + Math.sin(now * .00037) * 1.8).toFixed(2)}px`);

    const rhythmReveal = smooth(clamp((progress - .31) / .145));
    sticky.style.setProperty('--rhythm-curtain-top', `${((1 - rhythmReveal) * 100).toFixed(3)}%`);
    sticky.style.setProperty('--rhythm-curtain-y', `${((1 - rhythmReveal) * 8).toFixed(3)}%`);
    const rhythmProgress = clamp((progress - .43) / .27);
    const pointerDay = (state.pointerY - .5) * .12 * smooth(clamp((rhythmReveal - .55) / .45));
    const dayProgress = clamp(rhythmProgress + pointerDay);
    const activeDay = Math.min(14, Math.max(1, Math.round(1 + dayProgress * 13)));
    const skinToneProgress = (activeDay - 1) / 13;
    sticky.style.setProperty('--rhythm-skin-brightness', (1.24 - skinToneProgress * .31).toFixed(3));
    sticky.style.setProperty('--rhythm-skin-saturation', (.52 + skinToneProgress * .8).toFixed(3));
    sticky.style.setProperty('--rhythm-skin-sepia', (skinToneProgress * .23).toFixed(3));
    sticky.style.setProperty('--rhythm-skin-contrast', (.96 + skinToneProgress * .09).toFixed(3));
    dayReadout.textContent = `${activeDay}`.padStart(2, '0');
    dayTicks.forEach((tick, index) => {
      const active = index < activeDay;
      const peak = index === activeDay - 1;
      tick.style.setProperty('--day-height', peak ? '29px' : active ? '17px' : '5px');
      tick.style.setProperty('--day-color', active ? '#e4b574' : 'rgba(236,193,133,.28)');
    });
    finaleSplitReadouts.forEach(readout => { if (readout) readout.textContent = `${activeDay}`.padStart(2, '0'); });
    finaleSplitTickSets.forEach(ticks => ticks.forEach((tick, index) => {
      const active = index < activeDay;
      const peak = index === activeDay - 1;
      tick.style.setProperty('--day-height', peak ? '29px' : active ? '17px' : '5px');
      tick.style.setProperty('--day-color', active ? '#e4b574' : 'rgba(236,193,133,.28)');
    }));
    sticky.style.setProperty('--rhythm-drift', `${((state.pointerX - .5) * 14 + (dayProgress - .5) * 10).toFixed(2)}px`);

    const finaleReveal = smooth(clamp((progress - .72) / .14));
    const finaleSplitReveal = smooth(clamp((progress - .745) / .125));
    finalePanel.style.visibility = progress >= .68 ? 'visible' : 'hidden';
    if (finaleSplitGate) finaleSplitGate.style.visibility = progress >= .68 && progress < .88 ? 'visible' : 'hidden';
    finaleSplitPieces.forEach(piece => {
      const direction = Number(piece.dataset.direction);
      const hinge = direction * finaleSplitReveal * 1.1;
      piece.style.transform = `translate3d(0, ${(direction * finaleSplitReveal * 103).toFixed(3)}%, 0) rotateX(${hinge.toFixed(3)}deg)`;
    });
    const seamIntro = smooth(clamp((progress - .69) / .03));
    const seamFade = 1 - smooth(clamp((finaleSplitReveal - .04) / .62));
    sticky.style.setProperty('--finale-seam-alpha', `${(seamIntro * seamFade).toFixed(3)}`);
    sticky.style.setProperty('--finale-seam-scale', `${(.12 + seamIntro * .88).toFixed(3)}`);
    if (seamLine) seamLine.style.visibility = progress >= .69 && progress < .84 ? 'visible' : 'hidden';
    finaleLines.forEach((line, index) => {
      const local = smooth(clamp((finaleReveal - index * .13) / .72));
      line.style.setProperty('--finale-line-y', `${((1 - local) * 118).toFixed(2)}%`);
    });
    requestAnimationFrame(render);
  }
  requestAnimationFrame(render);
})();
